module.exports = __webpack_public_path__ + "static/media/icon_picture.f613a0b5.svg";